import * as React from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

import AppIcon from '~/client/components/AppIcon'
import DataPalLogo from '~/client/components/DataPalLogo'

export default function AppIconConnectToDataPalIcon({ app }){
  return <Stack
    direction="row"
    alignItems="center"
    justifyContent="center"
  >
    <AppIcon app={app} sx={{
      m: 0,
      width: 100,
      height: 100,
      fontSize: 50,
    }}/>
    <Box sx={{position: 'relative'}}>
      <CheckCircleIcon
        color="success"
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      />
      <Box sx={{
        width: '100px',
        borderBottom: 1,
        borderBottomStyle: 'dashed',
        borderColor: 'divider',
      }}></Box>
    </Box>
    <DataPalLogo sx={{
      height: 100,
      width: 100,
    }}/>
  </Stack>
}
